import CampaignAdd from "./CampaignAdd";
import CampaignEdit from "./CampaignEdit";
import CampaignList from "./CampaignList";

export default {
  list: CampaignList,
  edit: CampaignEdit,
  add: CampaignAdd,
};
